import { useEffect, useMemo, useState } from 'react';

type Density = 'compact' | 'comfortable' | 'spacious';

export function useScheduleViewportDensity() {
  const [windowHeight, setWindowHeight] = useState<number>(() => {
    if (globalThis.window === undefined) return 900;
    return globalThis.window.innerHeight;
  });

  useEffect(() => {
    if (globalThis.window === undefined) return undefined;
    const onResize = () => setWindowHeight(globalThis.window.innerHeight);
    globalThis.window.addEventListener('resize', onResize);
    return () => globalThis.window.removeEventListener('resize', onResize);
  }, []);

  const density = useMemo<Density>(() => {
    if (windowHeight < 820) return 'compact';
    if (windowHeight < 1040) return 'comfortable';
    return 'spacious';
  }, [windowHeight]);

  const rowPxByDensity: Record<Density, number> = {
    compact: 24,
    comfortable: 28,
    spacious: 32,
  };
  const rowPx = rowPxByDensity[density];
  const gridMaxHeight = Math.max(420, Math.min(860, Math.round(windowHeight * 0.66)));

  return { density, rowPx, gridMaxHeight };
}

